// Load Styles
import '../scss/main.scss';

// Load Bootstrap init
import {initBootstrap} from "./bootstrap.js";

// Import Splide
import Splide from '@splidejs/splide';

// Loading bootstrap with optional features
initBootstrap({
  tooltip: true,
  popover: true,
  toasts: true,
});

// Your app code
let info_slider = new Splide( '#change-maker-team-reqs', {
  type: 'loop',
  height: '300px',
  direction   : 'ttb',
  arrows: false,
  pagination: false,
  perPage: 2,
  perMove: 1,
  gap: '7rem',
  autoplay: true,
  pauseOnHover: true,
  interval: 2500,
  speed: 500,
  rewind: true,
  mediaQuery: 'max',
  wheel: true,
  releaseWheel: true,
  wheelSleep: 500,
  breakpoints: {
    768: {
      destroy: true
    }
  }
} ).mount();

info_slider.on('moved', (index) => {
  let hrn = index + 1;
  document.querySelector('.curr-slide-count').textContent = '0' + hrn.toString();
});

let responsible_slider = new Splide( '#changemaker-responsible-for', {
  type: 'loop',
  height: '700px',
  direction: 'ttb',
  arrows: false,
  pagination: false,
  perPage: 1,
  perMove: 1,
  autoplay: false,
  pauseOnHover: true,
  interval: 3500,
  speed: 500,
  rewind: true,
  drag: false,
  mediaQuery: 'max',
  breakpoints: {
    768: {
      destroy: true
    }
  }
} ).mount();

responsible_slider.on('move', (index, prevIndex) => {
  let prevControl = document.querySelector('.responsibles-text[data-slideto="'+prevIndex+'"]');
  let controls = document.querySelector('.responsibles-text[data-slideto="'+index+'"]');
  prevControl.classList.remove('active');
  controls.classList.add('active');
});

let resp_slider_controls = document.getElementsByClassName('responsibles-text');
for(var i =0; i < resp_slider_controls.length; i++){
  resp_slider_controls.item(i).addEventListener("click", function(e){
    e.preventDefault();
    let indexToGo = parseInt(e.target.dataset.slideto);
    responsible_slider.go(indexToGo);
  });
}